import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastProvider } from '@/shared/contexts/ToastContext';
import { ThemeProvider } from '@/shared/contexts/ThemeProvider';
import { AuthProvider } from '@/shared/contexts/AuthContext';
import ToastContainer from '@/shared/components/ui/ToastContainer';
import { queryClient } from '@/shared/lib';
import { ErrorDialogProvider } from '@/shared/components/ui/ErrorDialog';
import { ConfirmDialogProvider } from '@/shared/components/ui/ConfirmDialog';

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <ThemeProvider>
      <ErrorDialogProvider>
        <ConfirmDialogProvider>
          <AuthProvider>
            <ToastProvider>
              <QueryClientProvider client={queryClient}>

                {children}
                <ReactQueryDevtools initialIsOpen={false} />

                <ToastContainer />

              </QueryClientProvider>
            </ToastProvider>
          </AuthProvider>
        </ConfirmDialogProvider>
      </ErrorDialogProvider>
    </ThemeProvider>
  );
};
